
import {ModalFutureAbsenceModes} from "root/s360components/Modals/FutureAbsence/useModalFutureAbsence";
import FutureAbsenceCreateFragment, {
} from "root/s360components/Modals/FutureAbsence/FutureAbsenceCreateFragment";
import React, {Fragment, useEffect, useState} from "react";
import ModalButton from "root/Modals/ModalButton";
import {useForm} from "react-hook-form";
import AbsenceCodesProvider from "root/s360components/Contexts/AbsenceCodes/AbsenceCodesProvider";
import FutureAbsenceEditFragment from "root/s360components/Modals/FutureAbsence/FutureAbsenceEditFragment";
import FutureAbsenceDeleteFragment from "root/s360components/Modals/FutureAbsence/FutureAbsenceDeleteFragment";
import {ALL_SESSION_OBJ, AM_OBJ, PM_OBJ} from "root/s360components/ReactHookForm/ui/DropdownAMPM";
import './FutureAbsenceCreateFragment.scss';
import {
    createFutureAbsenceForPupil, deleteFutureAbsenceById,
    editFutureAbsenceById,
    getFutureAbsenceForId
} from "root/DataFunctions/FutureAbsenceDataFns";
import format from "date-fns/format";


export const ModalFutureAbsenceSections = {
    CREATE: 'create',
    EDIT: 'edit',
    DELETE: 'delete'
}

export const ModalFutureAbsenceSectionsNames = {
    ABS_FROM: 'abs_from',
    ABS_TO: 'abs_to',
    PUPIL: 'pupil',
    CLASS: 'class',
    ABS_CODE: 'absence_code',
    NOTES: 'notes',
    SESSION: 'session',
    FULL_NAME: 'fullname',
}

const FutureAbsenceDefaults = () =>
{
    return {
        [ModalFutureAbsenceSections.CREATE]:
            {
                [ModalFutureAbsenceSectionsNames.CLASS]: null,
                [ModalFutureAbsenceSectionsNames.PUPIL]: null,
                [ModalFutureAbsenceSectionsNames.ABS_CODE]: null,
                [ModalFutureAbsenceSectionsNames.ABS_FROM]: new Date(),
                [ModalFutureAbsenceSectionsNames.ABS_TO]: new Date(),
                [ModalFutureAbsenceSectionsNames.SESSION]: ALL_SESSION_OBJ,
                [ModalFutureAbsenceSectionsNames.NOTES]: "",
            },
        [ModalFutureAbsenceSections.EDIT]:
            {
                [ModalFutureAbsenceSectionsNames.ABS_CODE]: null,
                [ModalFutureAbsenceSectionsNames.ABS_FROM]: new Date(),
                [ModalFutureAbsenceSectionsNames.ABS_TO]: new Date(),
                [ModalFutureAbsenceSectionsNames.SESSION]: ALL_SESSION_OBJ,
                [ModalFutureAbsenceSectionsNames.NOTES]: "",
            },
        [ModalFutureAbsenceSections.DELETE]:
            {
                [ModalFutureAbsenceSectionsNames.FULL_NAME]: null,
                [ModalFutureAbsenceSectionsNames.ABS_FROM]: null,
                [ModalFutureAbsenceSectionsNames.ABS_CODE]: null,
                [ModalFutureAbsenceSectionsNames.ABS_TO]: null
            }
    }
}

const ModalFutureAbsence = ({longTermAbsenceID, mode, onSaveComplete, onClose, school_id}) =>
{

    const [selectedAbsenceCode, setSelectedAbsenceCode] = useState(null);

    const {register, control, reset, resetField, getValues, handleSubmit, setFocus, watch, setError, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                ...FutureAbsenceDefaults()
            }
        });

    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        formErrors: formErrors,
    }

    const pageModeDescriptors = {
        [ModalFutureAbsenceModes.NONE] : {fragment: Fragment, saveButtonText: '' , pageTitle: '' },
        [ModalFutureAbsenceModes.CREATE] : {sectionName: ModalFutureAbsenceSections.CREATE, fragment: FutureAbsenceCreateFragment , saveButtonText: 'Create' , pageTitle: 'Create Absence' },
        [ModalFutureAbsenceModes.EDIT] : {sectionName: ModalFutureAbsenceSections.EDIT, fragment: FutureAbsenceEditFragment , saveButtonText: 'Confirm' , pageTitle: 'Edit Absence' },
        [ModalFutureAbsenceModes.DELETE] : {sectionName: ModalFutureAbsenceSections.DELETE, fragment: FutureAbsenceDeleteFragment , saveButtonText: 'Delete' , pageTitle: 'Delete Absence' },
    }

    const getData = (longTermAbsenceID) =>
    {
        getFutureAbsenceForId(longTermAbsenceID, (response) =>
        {
            const row = response.results.record_set[0];

            const cur = getValues(sectionName);

            resetField(sectionName, {defaultValue: {
                    ...cur, [ModalFutureAbsenceSectionsNames.FULL_NAME]: row.fullname,
                    [ModalFutureAbsenceSectionsNames.ABS_FROM]: new Date(row.absence_from_date),
                    [ModalFutureAbsenceSectionsNames.ABS_TO]: new Date(row.absence_to_date),
                    [ModalFutureAbsenceSectionsNames.NOTES]: row.notes,
                }});

            setValue(ModalFutureAbsenceModes.EDIT + '.' + ModalFutureAbsenceSectionsNames.SESSION, findSessionFromOptions(row.session));

            setSelectedAbsenceCode(row.absence_code);
        })
    }

    const findSessionFromOptions = (session) =>
    {
        const sessions = [AM_OBJ, PM_OBJ, ALL_SESSION_OBJ];

        return sessions.find((element) => element.label === session);
    }

    useEffect(() =>
    {
        if (longTermAbsenceID !== null)
        {
            getData(longTermAbsenceID);
        }
    },[])

    const onSaveCompleted = () =>
    {
        onSaveComplete('saved');
        onClose();
    }

    const onClickCancel = () =>
    {
        onSaveComplete('cancel');
        onClose();
    }

    const FutureAbsenceFragment = pageModeDescriptors[mode].fragment;
    const saveButtonText = pageModeDescriptors[mode].saveButtonText;
    const pageTitle = pageModeDescriptors[mode].pageTitle;
    const sectionName=pageModeDescriptors[mode].sectionName;

    const dangerColor = mode === ModalFutureAbsenceModes.DELETE ? 'btn-danger' : 'btn-primary';

    const disableButtons = false; //TEMP

    const onSubmit = (formData) =>
    {
        formData[mode].abs_from = format(formData[mode].abs_from, 'yyyy-MM-dd');
        formData[mode].abs_to = format(formData[mode].abs_to, 'yyyy-MM-dd');

        switch(mode)
        {
            case ModalFutureAbsenceModes.CREATE:
                createFutureAbsenceForPupil(longTermAbsenceID, formData, (response) =>
                {
                    onSaveCompleted();
                });
                break;
            case ModalFutureAbsenceModes.EDIT:
                editFutureAbsenceById(longTermAbsenceID, formData,(response) =>
                {
                    onSaveCompleted();
                })
                break;
            case ModalFutureAbsenceModes.DELETE:
                deleteFutureAbsenceById(longTermAbsenceID,(response) =>
                {
                    onSaveCompleted();
                })
                break;
            default:
                break;
        }

    }

    const onClickSubmitForm = (formData) =>
    {
        handleSubmit(onSubmit)(formData)
    }

    return (
        <Fragment>
            <AbsenceCodesProvider>
                <div className='future-absence-modal'>
                    <h2>{pageTitle}</h2>
                    {mode !== ModalFutureAbsenceModes.NONE &&
                        <FutureAbsenceFragment school_id={school_id} sectionName={sectionName} {...controlProps}
                                               key={sectionName} setValue={setValue} selectedAbsenceCode={selectedAbsenceCode}/>}
                    {mode === ModalFutureAbsenceModes.NONE && <FutureAbsenceFragment key={sectionName}/>}
                    <div className='modal-buttons'>
                        <ModalButton onClick={onClickCancel} text='Cancel' iconClass='et-arrow-bold-left'
                                     additionalClass='btn-secondary' disabled={disableButtons}/>
                        <ModalButton onClick={onClickSubmitForm} text={saveButtonText} iconClass='et-check'
                                     additionalClass={dangerColor} disabled={disableButtons}/>
                    </div>
                </div>
            </AbsenceCodesProvider>
        </Fragment>
    )
}

export default ModalFutureAbsence;